import { Minus, Plus, Truck } from "lucide-react";
import { imageUrl, formatINR } from "@/lib/lamka";

export const OrderSummary = ({ item, qty, setQty, size, colour, locked }) => {
  const max = Math.max(1, item.stock || 1);
  return (
    <div data-testid="order-summary" className="bg-white border border-[#C5A059]/25 p-5 sm:p-6">
      <p className="eyebrow mb-5">Order summary</p>
      <div className="flex gap-4">
        <div className="w-20 sm:w-24 aspect-[3/4] bg-[#F5EFE6] shrink-0 overflow-hidden">
          {item.images?.[0] && <img src={imageUrl(item.images[0])} alt="" className="h-full w-full object-cover" />}
        </div>
        <div className="min-w-0 space-y-1.5">
          <p data-testid="summary-title" className="font-display text-lg leading-snug break-words">{item.title}</p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#71717A]">by {item.seller_name}</p>
          {size && <p data-testid="summary-size" className="text-sm text-[#3f3f46]">Size: {size}</p>}
          {colour && <p data-testid="summary-colour" className="text-sm text-[#3f3f46]">Colour: {colour}</p>}
        </div>
      </div>

      <div className="mt-6 space-y-3 text-sm">
        <Row label="Price">
          <span data-testid="summary-unit-price" className="font-mono break-all">{formatINR(item.price)}</span>
        </Row>
        <Row label="Quantity">
          <div className="flex items-center border border-[#0F0F0F]/20">
            <button data-testid="qty-decrease" disabled={locked || qty <= 1} onClick={() => setQty(qty - 1)} className="p-2 disabled:opacity-30"><Minus className="h-3.5 w-3.5" /></button>
            <span data-testid="summary-qty" className="w-8 text-center font-mono">{qty}</span>
            <button data-testid="qty-increase" disabled={locked || qty >= max} onClick={() => setQty(qty + 1)} className="p-2 disabled:opacity-30"><Plus className="h-3.5 w-3.5" /></button>
          </div>
        </Row>
        <Row label="Delivery">
          <span data-testid="summary-delivery" className="flex items-center gap-2 text-[#3f3f46]"><Truck className="h-4 w-4" strokeWidth={1.5} />{item.delivery_time || "Seller will confirm"}</span>
        </Row>
        <div className="border-t border-[#C5A059]/25 pt-4 flex justify-between items-baseline gap-4">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em]">Total</span>
          <span data-testid="summary-total" className="font-display text-2xl break-all">{formatINR(item.price * qty)}</span>
        </div>
      </div>
    </div>
  );
};

const Row = ({ label, children }) => (
  <div className="flex justify-between items-center gap-4">
    <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#71717A]">{label}</span>
    {children}
  </div>
);
